<template>
    <div class="supplier_score">
        <v-alert outlined text color="purple" dense> この画面は作成中です。</v-alert>
        <v-card class="mx-auto my-3" outlined v-for="review in reviews" :key="review.id">

            <v-container>
                <v-row>
                    <v-col>
                      <v-avatar>
                        <img
                            src="https://cdn.vuetifyjs.com/images/john.jpg"
                            alt="John"
                        >
                      </v-avatar>
                      <span class="ml-2">
                        {{review.staff_name}}
                      </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                      <span>投稿日：</span>
                      <span class="subtitle-1">{{review.dt}}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                      <p class="body-1">
                        {{review.content}}
                      </p>
                    </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="d-flex flex-row">
                      <v-card tile v-for="imgno in review.images" :key="imgno" class="ma-1">
                        <v-img
                            :src="`https://picsum.photos/500/300?image=${imgno}`"
                            :lazy-src="`https://picsum.photos/10/6?image=${imgno}`"
                            aspect-ratio="1"
                            max-width="150"
                            min-height="150"
                            min-width="150"
                        ></v-img>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>

            </v-container>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon><v-icon>mdi-thumb-up-outline</v-icon></v-btn>
                <span class="caption">21人が「いいね!」しました。</span>
            </v-card-actions>
        </v-card>

    </div>
</template>
<script>

import BaseView from "../../components/BaseView";

export default {
    mixins:[BaseView],
    components: {

    },
    props: {
        reviews: Array
    },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        condition:{},
        pager:{},
        errors:{},
    }),
    computed: {

    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){

        },

    },

}
</script>